import Styled from "styled-components";

export type LightMode = "light-mode" | "dark-mode";

export interface VideoContainerProps {
  $videoW: number;
  $videoH: number;
  $variant?: LightMode;
}

export interface YoutubeIframeProps {
  $allowfullscreen: boolean;
  $variant?: LightMode;
}

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div`
  position: relative;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }
  
  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const VideoContainer = Styled.div<VideoContainerProps>`
  position: relative;
  height: 0;
  padding-bottom: ${(props) =>
    props.$videoH || props.$videoH
      ? Math.round((props.$videoH / props.$videoW) * 100)
      : Math.round((props.$videoH / props.$videoW) * 100)}%;
  margin: 0 auto;
  border-radius: 32px;
  overflow: hidden;

  ${(props) =>
    props.$variant === "dark-mode" &&
    `
    box-shadow: 0px -20px 200px rgba(68, 20, 187, 0.75);
  `};

  ${(props) => props.theme.breakpoints.up("medium")} {
    margin: 0 auto;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    height: 686px;
    padding-bottom: 52%;
  }
`;

export const YoutubeIframe = Styled.iframe<YoutubeIframeProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0 auto 6.25rem auto;
  border: none;
  box-shadow: 0px -20px 200px rgba(68, 20, 187, 0.75);
  border-radius: 32px;
  overflow: hidden;

  ${(props) =>
    props.$variant === "dark-mode" &&
    `
    box-shadow: 0px -20px 200px rgba(68, 20, 187, 0.75);
  `};

  ${(props) => props.theme.breakpoints.up("large")} {
    height: 686px;
  }
`;
